module.exports = ".cover-image {\r\n    margin-top: 25px;\r\n    height: 150px;\r\n    width: 150px;\r\n}"